import { BannerContext } from 'components/Routes/BannerContext';
import OverlayStdContainer from 'components/Overlays/OverlayStdContainer';
import ViewMapLayers from 'components/ViewMapLayers';
import { useMapLayersManager } from 'providers/MapLayersManagerProvider';
import React, { useContext, useEffect } from 'react';
import {
  MapOverlayMachineEventsEnum,
  useMapOverlayMachine,
} from '../MapOverlayMachine';

const ViewMapLayersOverlay: React.FC = () => {
  const mapLayersManager = useMapLayersManager();
  const { mappedSheetQuery, queriedMappedSheets, mappedSheetVersions } =
    mapLayersManager;

  const { mapOverlayMachineService } = useMapOverlayMachine();
  const { height: bannerHeight } = useContext(BannerContext);
  useEffect(() => {
    mapLayersManager.queryMappedSheets();
  }, [mappedSheetVersions]);

  const launchDrawingSelectionModal = () => {
    mapLayersManager.launchDrawingSelectionModal();
  };

  const topHeight = `calc(96px + ${bannerHeight}px)`;
  const mapHeight = `calc(100vh - ${topHeight})`;

  return (
    <OverlayStdContainer
      id="view-map-layers-overlay"
      style={{
        right: 'initial',
        top: topHeight,
        height: mapHeight,
      }}
    >
      <ViewMapLayers
        allowItemEdit
        launchDrawingSelectionModal={launchDrawingSelectionModal}
        onCancelClick={() => {
          mapOverlayMachineService.send(
            MapOverlayMachineEventsEnum.CLOSE_OVERLAY
          );
        }}
        queriedMappedSheetsCount={queriedMappedSheets.count()}
        showAddNewLayer
        startingSortDirection={mappedSheetQuery.sortDirection}
        startingSortField={mappedSheetQuery.sortField}
      />
    </OverlayStdContainer>
  );
};

export default ViewMapLayersOverlay;
